export const COLUMN_ORDER = "minmax(12rem, 4fr) 1fr 1fr";
